<template>
    <div class="d-lg-none d-flex justify-content-between px-4 bg-white py-3 position-fixed bottom-0 w-100 floating-nav align-items-center">
        <a href="#" class="d-flex flex-column align-items-center text-decoration-none">
            <img src="@/assets/images/nav-imgs/home.svg" alt="">
            <span class="text-primary fs-12px active">الرئيسية</span>
        </a>
        <a href="#" class="d-flex  flex-column align-items-center text-decoration-none">
            <img src="@/assets/images/nav-imgs/calendar.2.svg" alt="">
            <span class="text-primary fs-12px">مواعيدي</span>
        </a>
        <a href="#" class="d-flex  flex-column align-items-center text-decoration-none">
            <img src="@/assets/images/nav-imgs/link.1.svg" alt="">
            <span class="text-primary fs-12px">ربط الخدمات</span>
        </a>
        <a href="#" class="d-flex  flex-column align-items-center text-decoration-none">
            <img src="@/assets/images/nav-imgs/message.svg" alt="">
            <span class="text-primary fs-12px">المساعدة</span>
        </a>
        <a href="#" class="d-flex  flex-column align-items-center text-decoration-none">
            <img src="@/assets/images/user_2x.png" width="24" alt="">
            <span class="text-primary fs-12px">المزيد</span>
        </a>

    </div>
</template>
